module.exports = require("@jswork/next-slate-serialize");